export default {
  navbar: {
    about: 'about',
    whatido: 'what I do',
    works: 'works',
    journey: 'journey',
    contact: 'contact',
    theme: 'Theme',
  },
  footer: {
    rights: 'All rights reserved',
    made: 'Made with',
    cta: {
      title1: "let's build",
      title2: 'something',
      titleAccent: 'extraordinary',
      description: 'Have a project in mind or just want to connect? Drop me a line',
    },
  },
  notFound: {
    title: 'Page Not Found',
    description: 'Sorry, the page you are looking for does not exist or has been moved.',
    goHome: 'Go Home',
    goBack: 'Go Back',
  },
  close: 'Close',
  readMore: 'Read More',
  readLess: 'Read Less',
  tiltToExplore: 'Tilt to explore',
  tapToExplore: 'Tap to explore',
}
